import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SIGNIN_REQUEST, SignInRequestType } from "./types";

interface SignInState {
  response: any | null;
  loading: boolean;
  error: any | null;
}

const usersInitialState: SignInState = {
  response: null,
  loading: false,
  error: null,
};

export const signInSlice = createSlice({
  name: SIGNIN_REQUEST,
  initialState: usersInitialState,
  reducers: {
    signInRequest(state, action: PayloadAction<SignInRequestType>) {
      state.loading = true;
      state.error = null;
    },
    signInSuccess(state, action: PayloadAction<{ response: any }>) {
      state.loading = false;
      state.response = action.payload.response;
    },
    signInFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
  },
});

export const { signInRequest, signInSuccess, signInFailure } =
  signInSlice.actions;
export default signInSlice.reducer;
